<template>
  <div>
    <div class="regionAddManager">
      <el-row class="regionAddManager_input">
        <el-col :span="8">
          <el-form ref="form" >
            <span class="title_manager">子管理员名字</span>
            <el-input
              v-model="addmanagerAccount.agent_name"
              maxlength="10"
              class="elInput"
              placeholder="名称"
            ></el-input>
          </el-form>
        </el-col>
        <el-col :span="8">
          <el-form ref="form" >
            <span class="title_manager">子管理员账号</span>
            <el-input
              v-model="addmanagerAccount.account"
              maxlength="11"
              class="elInput"
              placeholder="手机号码"
            ></el-input>
            <el-button type="primary" class="elButton" @click="confirmOpening()">新建子管理员</el-button>
          </el-form>
        </el-col>
      </el-row>
    </div>
    
    <div class="registrationSurface">
      <div class="table_conent">
        <template>
          <div class="table_title">子管理员列表</div>

          <el-table
            class="tableBox"
            :header-cell-style="{background:'#F1F6F9',color:'#606266',width: '100%'}"
            :data="tableData"
            border
          >
            <el-table-column label="子管理员名字" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.agent_name}}</span>
              </template>
            </el-table-column>
            
            <el-table-column label="子管理员账号" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.account_number}}</span>
              </template>
            </el-table-column>
            <el-table-column label="开通时间" align="center">
               <template slot-scope="scope">
                 <span>{{scope.row.created_at}}</span>
              </template>
            </el-table-column>

            <!-- <el-table-column label="操作" align="center" width="400">
              <el-button type="danger" plain size="mini" class="table_btn">删除此经理</el-button>
            </el-table-column>-->
          </el-table>
        </template>
      </div>
    </div>
      <!-- <div style="text-align: right;">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      addmanagerAccount: {
        agent_name: "",
        account: ""
      },

      tableData: []
    };
  },
  created() {
    this.initManager();
  },
  methods: {
    // 新增区域经理
    confirmOpening() {
      if (!this.addmanagerAccount.agent_name) {
        return this.$message.error("请输入子管理员真实名字");
      }
      if (!this.addmanagerAccount.account) {
        return this.$message.error("请输入子管理员手机号");
      }
      this.$http
        .post(this.$api.api.create_manege, this.addmanagerAccount)
        .then(res => {
          if (res.data.code != 1) {
            return this.$message.error(res.data.result);
          }
          this.$message.success(res.data.result);
          this.initManager();
          this.addmanagerAccount.agent_name = "";
          this.addmanagerAccount.account = "";
        });
    },

    initManager() {
      this.$http.get(this.$api.api.read_manage).then(res => {
        if (res.data.code != 1) {
          return this.$message.error(res.data.result);
        }
        this.tableData = res.data.result;
      });
    }
  }
};
</script>
 <style>
</style>
<style scoped lang="scss">
.elInput {
  width: 35%;
}

.tableBox {
  height: 100%;
}
.regionAddManager_input {
  padding: 20px 0px;
  .title_manager {
    margin-right: 10px;
    color: #727272;
    font-size: 14px;
  }
}
.elButton {
  margin-left: 50px;
}
.registrationSurface {
  overflow: auto;
  .table_conent {
    padding-top: 10px;
    .table_title {
      border: 1px solid #ebeef5;
      border-bottom: 0px;
      text-align: center;
      font-size: 18px;
      font-weight: bold;
      height: 49px;
      line-height: 49px;
      background: #f1f6f9;
    }
    .table_btn {
      width: 80px !important;
    }
  }
}
</style>